var _path, _circle, _ellipse, _circle2, _circle3, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartScatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.813599V15.1865H17",
    stroke: "#A3AEB8",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.98301,
    cy: 12.4746,
    r: 1.35593,
    fill: "#338ECC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.40684,
    cy: 10.8475,
    rx: 1.35593,
    ry: 1.35593,
    fill: "#338ECC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.6102,
    cy: 8.1356,
    r: 1.35593,
    fill: "#338ECC",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.40684,
    cy: 6.50852,
    r: 1.35593,
    fill: "#338ECC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.7457,
    cy: 5.96616,
    rx: 1.35593,
    ry: 1.35593,
    fill: "#338ECC",
    fillOpacity: 0.25
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.4576,
    cy: 2.46128,
    rx: 1.35593,
    ry: 1.35593,
    fill: "#338ECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartScatter);
export default __webpack_public_path__ + "static/media/chart-scatter.69118d0023a6ff3973f7fa913834ac47.svg";
export { ForwardRef as ReactComponent };